import { Container } from "@mui/material";
import { HeaderWrapper } from "./styles/common.styled";
import { NavLink } from "react-router-dom";

export const Header = () => {
  return (
    <HeaderWrapper>
      <Container
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <div>
          <NavLink to="/home">
            <span>Bill Reader</span>
          </NavLink>
        </div>
        <div>
          <NavLink to="/about_us">
            <span>About us</span>
          </NavLink>
          <NavLink to="/contact">
            <span>Contact us</span>
          </NavLink>
        </div>
      </Container>
    </HeaderWrapper>
  );
};
